import { CapoPlugin } from "/opt/build/repo/node_modules/.pnpm/@unhead+vue@1.9.16_vue@3.4.38_typescript@5.5.4_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];